import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            isAuthenticated: "security/isAuthenticated"
        }),
        currentUserId()
        {
            return this.$store.state.security.jwtPayload?.userId;
        }
    }
}